import { useSelector } from "react-redux";
import { RootState } from "../../store";
import useWindowWidth from "../../hooks/useWindowWidth";
import { formatDateTime } from "../../helpers/date-time/dateTimeHelpers";
import ResponsivePaymentTable from "./ResponsivePaymentTable";

const OnlinePaymentTable: React.FC = () => {

    const reportState = useSelector((state: RootState) => state.reportState);
    const { appointmentList } = reportState;
    const { windowWidth } = useWindowWidth()

    return (
        <>
            {
                windowWidth >= 1000 
                ?
            
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Treatment</th>
                            <th>Price</th>
                            <th>Paid Amount</th>
                            <th>Refund Amount</th>
                            <th>Client Name</th>
                            <th>Payment Method</th>
                        </tr>
                    </thead>
                    <tbody>
                        {appointmentList.map(appointment => {
                            const { 
                                _id,
                                appointment_date,
                                treatment,
                                clientName,
                                paymentList,
                                refund
                            } = appointment;

                            const { day, month, year, hours, minutes } = formatDateTime(new Date(appointment_date * 1000));

                            const paymentMadeOnline = paymentList?.find(item => item.online);
    
                            if(!paymentMadeOnline) return null;

                            return (
                                <tr key = {_id}>
                                    <td>{`${month} ${day}, ${year}`}</td>
                                    <td>{`${hours}:${minutes}`}</td>
                                    <td>{treatment?.title}</td>
                                    <td>€{treatment?.price.toFixed(2)}</td>
                                    <td>€{paymentMadeOnline.amount.toFixed(2)}</td>
                                    <td>€{refund?.amount ? refund?.amount.toFixed(2) : 0.00}</td>
                                    <td>{clientName}</td>
                                    <td>{paymentList?.map(item => item.method).join(", ")}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                :
                <ResponsivePaymentTable />
            }
        </>
    );

}

export default OnlinePaymentTable;